import * as R from "ramda";
import { STRUCTURE_CONTENT_CONSTRAINTS_PATH } from "./constants/content-constraints.mjs";
import { compareAsc } from "date-fns";
const getActualContentConstraintsArtefact = R.pipe(
  R.pathOr([], STRUCTURE_CONTENT_CONSTRAINTS_PATH),
  R.find((constraint) => {
    if (R.isNil(constraint)) return false;
    if (R.toLower(constraint.type) !== "actual") {
      return false;
    }
    const now = /* @__PURE__ */ new Date();
    if (!R.isNil(constraint.validTo)) {
      if (compareAsc(now, new Date(constraint.validTo)) !== -1) {
        return false;
      }
    }
    if (!R.isNil(constraint.validFrom)) {
      if (compareAsc(now, new Date(constraint.validFrom)) !== 1) {
        return false;
      }
    }
    return true;
  })
);
export {
  getActualContentConstraintsArtefact
};
